export default {
  all: () => ['messages'],
  index: (user_id?: string, conversation_id?: string, page?: number) => [
    'messages',
    { user_id, conversation_id, page },
  ],
  show: (message_id?: string) => ['message', { message_id }],
  result_tables: (message_id?: string) => ['message_result_tables', { message_id }],
  check_column: (
    message_id?: string,
    ids?: string[],
    lastPolledCounts?: { [key: string]: number }
  ) => ['message_check_columns', { message_id, ids, lastPolledCounts }],
  nested_messages: (messageId?: string) => ['nestedMessages', { messageId }],
  stock_prices: (
    message_id?: string,
    stock_id?: string,
    start_date?: string,
    end_date?: string,
    limit?: number
  ) => ['stock_prices', { message_id, stock_id, start_date, end_date, limit }],
  structured_data: (message_id?: string, stock_id?: string, data_type?: string) => [
    'execute_structured_data',
    { message_id, stock_id, data_type },
  ],
  company_page_batch_results: (message_id?: string, quarter?: number, year?: number) => [
    'company_page_batch_results',
    { message_id, quarter, year },
  ],
  earnings_history_status: (message_id?: string) => ['earnings_history_status', { message_id }],
  company_page_timeline: (message_id?: string) => ['company_page_timeline', { message_id }],
  check_latest_fy_fq: (stock_id?: string) => ['check_latest_fy_fq', { stock_id }],
  latest_fy_fq: (stock_id?: string) => ['latest_fy_fq', { stock_id }],
  stock_fy_fq: (message_id?: string) => ['stock_fy_fq', { message_id }],
}
